<template>
  <div id="show-client-portal-nas">
    <v-card class="mt-3">
      <v-card-title>
        NAS
        <v-spacer></v-spacer>

        <v-btn
          @click="createNasDialog = true"
          icon
          color="primary"
          v-if="!hideCreateButton && isGrantedUser()"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <create-nas-dialog
          v-if="createNasDialog && isGrantedUser()"
          :open.sync="createNasDialog"
          :nasIdentifier="true"
          :clientPortal="clientPortal"
          :partner="clientPortal.partner"
        ></create-nas-dialog>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <nas-datatable :clientId="clientPortal.id"></nas-datatable>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import NasDatatable from "@/components/Nas/NasDatatable";
import CreateNasDialog from "@/components/Nas/CreateNasDialog";
import { ref } from "@vue/composition-api";
import { useRoles } from "../../composables/roles";

export default {
  props: {
    clientPortal: Object,
    hideCreateButton: Boolean,
  },
  components: { NasDatatable, CreateNasDialog },
  setup() {
    const { isGrantedUser } = useRoles();

    return {
      createNasDialog: ref(false),
      isGrantedUser,
    };
  },
};
</script>
